import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import FingerprintJS from './fork/fingerprintjs';
import stages from './stages';
var X_CAST = 'x-cast';
var X_CAST_REQUESTED = 'x-cast-requested';
export default function getCast(sign, stage) {
  return new Promise(function (resolve) {
    var castUrl = "".concat(stages(stage), "/cast");
    var session = sessionStorage.getItem(X_CAST) || localStorage.getItem(X_CAST);

    var appendFrame = function appendFrame(data) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'getCast';
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = "".concat(castUrl).concat(data ? "?cast=".concat(data) : "?location=".concat(encodeURIComponent(window.location.origin)));
      iframe.name = name;

      if (data) {
        iframe.onload = function () {
          iframe.parentNode.removeChild(iframe);
        };
      }

      if (!(!!window.MSInputMethodContext && !!document.documentMode)) {
        document.body.appendChild(iframe);
      }
    };

    var listerCast = function listerCast(event) {
      if (/^http[s]{0,1}:\/\/[^/]*[.]{0,1}s7\.ru/gi.test(event.origin)) {
        try {
          var _JSON$parse = JSON.parse(event.data),
              type = _JSON$parse.type,
              cast = _JSON$parse.cast;

          if (type === 'getCast') {
            if (cast) {
              sessionStorage.setItem(X_CAST, cast);
              localStorage.setItem(X_CAST, cast);
              resolve(cast);
            } else if (sessionStorage.getItem(X_CAST_REQUESTED) !== 'true') {
              sessionStorage.setItem(X_CAST_REQUESTED, 'true');
              FingerprintJS.load().then(function (fp) {
                fp.get().then(function (data) {
                  var _navigator = navigator,
                      userAgent = _navigator.userAgent;
                  sign(_objectSpread(_objectSpread({}, data), {}, {
                    userAgent: userAgent
                  })).then(function (_ref) {
                    var jwt = _ref.data.jwt;
                    sessionStorage.setItem(X_CAST, jwt);
                    localStorage.setItem(X_CAST, jwt);
                    appendFrame(jwt, 'setCast');
                    resolve(jwt);
                  }).catch(function () {
                    sessionStorage.removeItem(X_CAST_REQUESTED);
                  });
                }).catch(function () {
                  sessionStorage.removeItem(X_CAST_REQUESTED);
                });
              }).catch(function () {
                sessionStorage.removeItem(X_CAST_REQUESTED);
              });
            }
          } // eslint-disable-next-line no-empty

        } catch (e) {}
      }
    };

    if (session) {
      appendFrame(session, 'sendCast');
      resolve(session);
    } else {
      window.addEventListener('message', listerCast);
      appendFrame();
    }
  });
}